import { defineMessages } from 'react-intl';

export const messages: {
	results: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	aiMode: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	results: {
		id: 'search-page.ai-mode.results',
		defaultMessage: 'Results',
		description: 'Label for the Results tab in AI mode toggle',
	},
	aiMode: {
		id: 'search-page.ai-mode.ai-mode',
		defaultMessage: 'AI Mode',
		description: 'Label for the AI Mode tab',
	},
});
